<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>操作日志</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="100px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="用户名或账号" prop="userName">
            <el-input size="small" style="width: 200px;" v-model="formInline.userName" placeholder="请输入用户名或账号"></el-input>
          </el-form-item>
          <el-form-item label="ip地址" prop="ipAddress">
            <el-input size="small" style="width: 200px;" v-model="formInline.ipAddress" placeholder="请输入ip地址"></el-input>
          </el-form-item>
          <el-form-item label="操作类型" prop="title">
            <el-input size="small" style="width: 200px;" v-model="formInline.title" placeholder="请输入操作类型"></el-input>
          </el-form-item>
          <el-form-item label="发送时间：" prop="datePicker">
            <el-date-picker style="height: 33px;width: 300px;"
                            v-model="times"
                            type="daterange"
                            @change="dataPicker"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"    highlight-current-row border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
            <el-table-column prop="title" label="操作名称" align="center"></el-table-column>
            <el-table-column prop="ipAddress" label="ip地址" align="center"></el-table-column>
            <el-table-column prop="userName" label="操作用户名称" align="center"></el-table-column>
            <el-table-column prop="account" label="操作用户账号" align="center"></el-table-column>
            <el-table-column align="center"  prop="createTime" label="发送时间" >
              <template slot-scope="scope">
                <div>{{scope.row.createTime|timestampToTime}}</div>
              </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import {qrySystemLogList} from '../../api/sysApi'
  import Pagination from '../../components/Pagination'
  import {timestampToTime,parseTime} from "../../utils/util";
  export default {
    name: "systemLogList",
    data() {
      return {
        times:'',
        formInline:{
          beginTime : '',
          endTime :'',
          ipAddress:'',
          title:'',
          userName:'',
          page:1,
          pageSize:10
        },
        listData:[],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    mounted() {
      this.tableList();
    },
    methods:{
      /**
       * @name: dataPicker
       * @Author: TJH
       * @msg: 时间选择器
       * @Date: 2021-02-25 14:47:12
       * @param value：[开始时间,结束时间]
       * @return {*}
       */
      dataPicker(value) {
        if (value != null) {
          console.log(value);
          this.formInline.beginTime = parseTime(
            value[0],
            "{y}-{m}-{d}"
          );
          this.formInline.endTime = parseTime(value[1], "{y}-{m}-{d}");
        } else {
          this.formInline.beginTime = "";
          this.formInline.endTime = "";
        }
      },
      tableList(){
        qrySystemLogList(this.formInline).then(res => {
          this.listData = res.data.list;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.pageSize;
          this.pageparm.total = res.data.total;
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage;
        this.formInline.pageSize = parm.pageSize;
        this.tableList();
      },
    },
    //分页组件
    components: {
      Pagination
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/system/systemLogList.vue